import { Expose } from 'class-transformer';

export class ImageProps {
  @Expose()
  src!: string;

  @Expose()
  alt!: string;
}
